// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".section.text__intro .box__logo img{max-width:350px}.section.text__intro .box__logo:hover .add-image{opacity:1}.text-intro__description p{max-width:100%}.text-intro__description span[style]{font-size:inherit!important;line-height:inherit!important}", ""]);
// Exports
module.exports = exports;
